import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

const UPDATE_INVENTORY_PLATES_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.UPDATE_INVENTORY_PLATES, 0).fields
);

export const UPDATE_INVENTORY_PLATES_V0_UI_SCHEMA = {
  ...UPDATE_INVENTORY_PLATES_BASE_UI_SCHEMA,
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['columnMapping'],
  columnMapping: {
    ...UPDATE_INVENTORY_PLATES_BASE_UI_SCHEMA.columnMapping,
    infoText:
      'Map columns from the input plates onto well schema fields on the inventory plates being updated.',
    fieldSettings: {
      columnSourceInputDataName: 'Input plates',
    },
  },
} as StepTypeConfigUISchemaV2<PipelineStepType.UPDATE_INVENTORY_PLATES, 0>;
